<template>
  <div class="no-data" :class="{ fill }">
    <v-icon x-large class="ma-2" color="primary">
      mdi-database-search
    </v-icon>
    <h3>{{ $t("message.common.noData") }}</h3>
    <p v-if="description" class="no-data__description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: {
    fill: {
      type: Boolean,
      default: false
    },
    description: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.no-data {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__description {
    text-align: center;
    font-size: 13px;
  }

  &.fill {
    flex: 1;
    height: 100%;
    width: 100%;
  }
}
</style>
